import "./App.css";
import Navbar from "./pages/Navbar";
import Footer from "./pages/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollTopButton from "./components/ScrollTopButton";
import AnimatedRoutes from "./components/AnimatedRoutes";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <>
      <LanguageProvider>
        <Navbar />
        <ScrollToTop />
        <AnimatedRoutes />
        <Footer />
        <ScrollTopButton />
      </LanguageProvider>
    </>
  );
}

export default App;
